import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/login/Login';
import { PUBLIC_PATHS } from '../app/constants';
import InTroScreen from '../pages/intro screen';

const UnAuthenticatedApp = () => {
  const { LOGIN, LANDING } = PUBLIC_PATHS;

  return (
    <Routes>
      <Route path={LANDING} element={<InTroScreen />} />
      <Route path={LOGIN} element={<Login />} />
      <Route path='/*' element={<Navigate to={LOGIN} replace />} />
    </Routes>
  );
};

export default UnAuthenticatedApp;
